import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.chime_deposit,
    (chime_deposit) => {
        return {
            stage: chime_deposit.stage,
            initialized: chime_deposit.initialized,
            works: chime_deposit.works
        }
    }
)